// extracted by mini-css-extract-plugin
module.exports = {"element":"backgroundBlock_element__1mbT2"};